// extracted by mini-css-extract-plugin
module.exports = {"DropdownNav":"NavDropdownMenu_DropdownNav__1W2Mw","Container":"NavDropdownMenu_Container__2R9dc","CloseBtn":"NavDropdownMenu_CloseBtn__1yRbH"};